import React from 'react';
import { AppState } from './App'
import './TooManyLogIn.css';

interface ComponentProps {
	changeState: (newState: AppState) => void
}

type State = { }
export default class TooManyLogIn extends React.Component<ComponentProps, State> {

	state: State

	constructor(props: ComponentProps) {
		console.log('TooManyLogIn')
		super(props)
		this.state = {}
	}

	render() {
		return (
			<div className="too-many-log-in-container">
				<div className="too-many-log-in-card">
					<form>
						<div className="logos">
							{/* Add your logos here */}
						</div>
						<h1>Too many log in attempts</h1>
						<div className="message">
							You have been blocked for the next 24hrs.
							<br/>
							Please check that you are using the correct phone number and try again tomorrow.
						</div>
					</form>
				</div>
			</div>
		);
	}
};
